import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import PageBase from '../components/PageBase';
import i18n from '../translations/i18n';

const propTypes = {
  t: PropTypes.func,
};

const NotFoundPage = props => <PageBase title={props.t('page_not_found')} />;

NotFoundPage.propTypes = propTypes;

const extended = translate(['translations'], { i18n })(NotFoundPage);
export default connect(null)(extended);



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage.js